import React, { Component } from 'react';
import { Helmet } from "react-helmet"
import scrollToComponent from 'react-scroll-to-component';
import data from "../../api/data.json"

import Promo from "../Promo/Promo"
import Readmore from "../Readmore/Readmore"
import ArticleSides from "../ArticleSides/ArticleSides"
import Analytics from "../Analytics/Analytics"
import Israelies from "../Israelies/Israelies"
import Buyers from "../Buyers/Buyers"
import Card from "../Card/Card"
import Creditor from "../Creditor/Creditor"
import Calendar from "../Calendar/Calendar"

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homepage: "section-promo",
      currScroll: this.props.goToSection,
      oldScroll: ""
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.oldScroll === this.props.goToSection) {
      if (this.getParameterByName("s")) {
        //alert("alon 1");
      } else {
        scrollToComponent(this.promo);
      }
    } else {
      switch (this.props.goToSection) {
        case "section-promo":
        default:
          if (this.getParameterByName("s")) {
            switch (this.getParameterByName("s")) {
              default:
              case "promo":
                window.setTimeout(() => {
                  scrollToComponent(this.promo);
                }, 100);
                break;
              case "sides":
                window.setTimeout(() => {
                  scrollToComponent(this.sides);
                }, 100);
                break;
              case "article1":
                window.setTimeout(() => {
                  scrollToComponent(this.card1);
                }, 100);
                break;
              case "article2":
                window.setTimeout(() => {
                  scrollToComponent(this.card2);
                }, 100);
                break;
              case "buyers":
                window.setTimeout(() => {
                  scrollToComponent(this.buyers);
                }, 100);
                break;
              case "credit":
                window.setTimeout(() => {
                  scrollToComponent(this.credit);
                }, 100);
                break;
              case "readmore":
                window.setTimeout(() => {
                  scrollToComponent(this.readmore);
                }, 100);
                break;
              case "calendar":
                window.setTimeout(() => {
                  scrollToComponent(this.calendar);
                }, 100);
                break;
            }
          } else {
               scrollToComponent(this.promo);
          }
          break;
        case "section-buyers":
          scrollToComponent(this.buyers);
          this.setState({
            oldScroll: this.props.goToSection
          })
          break;
        case "section-calendar":
          scrollToComponent(this.calendar);
          this.setState({
            oldScroll: this.props.goToSection
          })
          break;
        case "section-readmore":
          scrollToComponent(this.readmore);
          this.setState({
            oldScroll: this.props.goToSection
          })
          break;
        case "section-creditor":
          scrollToComponent(this.credit);
          this.setState({
            oldScroll: this.props.goToSection
          })
          break;
      }
    }
  }
  getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    //return decodeURIComponent(results[2].replace(/\+/g, " "));
    if (!decodeURIComponent(results[2].replace(/\+/g, " "))) {
      return false;
    } else {
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  }
  render() {
    window.document.querySelector("body").classList.remove("article");
    return (
      <div className="Isracard-Wrapper-Homepage">
        <Helmet>
          <title>ynet - איך קונים ברשת?</title>
        </Helmet>
        <div dangerouslySetInnerHTML={{ __html: `<!-- -->` }}></div>
        <Promo ref={(section) => { this.promo = section; }} />
        <ArticleSides ref={(section) => { this.sides = section; }} />
        <Analytics />
        <Buyers ref={(section) => { this.buyers = section; }} />
        <Israelies />
        <Card data={data.moreinfo[0]} ref={(section) => { this.card1 = section; }} />
        <Calendar ref={(section) => { this.calendar = section; }} />
        <Card data={data.moreinfo[1]} ref={(section) => { this.card2 = section; }} />
        <Creditor ref={(section) => { this.credit = section; }} />
        <Readmore ref={(section) => { this.readmore = section; }} />
      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/App/Homepage.js